import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';

const InsufficientCreditsForRetentionFeePaidByParent = ({ visible, insufficientCreditsData }) => {
  const { retentionPrice, creditBalance, gpiRepresentative } = insufficientCreditsData;
  const { parentAccountOwnerFullName, parentAccountOwnerEmail } = gpiRepresentative;

  return (
    <Dialog
      header="Your Credits balance is low"
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={visible}
      onHide={() => {}}
      position="center"
    >
      <p>{`Your Credits balance is ${creditBalance} which is not enough to pay the retention fee of ${retentionPrice} Credits`}</p>
      <p>Please contact your GPI representative to buy more Credits.</p>
      <p>Your GPI representative:</p>
      <p>Name: {`${parentAccountOwnerFullName}`}</p>
      <p>Email: {parentAccountOwnerEmail}</p>
      <div className="center">
        <Button
          type="button"
          className="p-button-primary"
          label="CONTACT GPI REPRESENTATIVE"
          onClick={() => {
            window.open(`mailto:${parentAccountOwnerEmail}`);
          }}
        />
      </div>
    </Dialog>
  );
};

export default InsufficientCreditsForRetentionFeePaidByParent;
